import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=eca89eda&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eca89eda')) {
      api.createRecord('eca89eda', component.options)
    } else {
      api.reload('eca89eda', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=eca89eda&", function () {
      api.rerender('eca89eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yH2NPZG5IzXu/JS/comp/ImgFallback.vue"
export default component.exports